import React from 'react';
import counterpart from 'counterpart';
import './DueDate.scss';
import { VITE_isIE } from 'Constants/appEnvConstants';

const DueDate = (daysLeft) => {
  let extraClass;
  let dummyDate;
  if (daysLeft.daysLeft) {
    if (daysLeft.daysLeft >= 11) {
      extraClass = 'eleven';
    } else if (daysLeft.daysLeft >= 6 && daysLeft.daysLeft <= 10) {
      extraClass = 'ten';
    } else if (daysLeft.daysLeft > 0 && daysLeft.daysLeft <= 5) {
      extraClass = 'five';
    } else { extraClass = 'expired'; }
  } else {
    dummyDate = daysLeft.daysLeft ? daysLeft.daysLeft : 0;
    extraClass = 'expired';
  }

  return (
    <div className={`duedate duedate-${extraClass}`}>
      {daysLeft.daysLeft ? daysLeft.daysLeft : dummyDate}
      <span className={VITE_isIE ? 'duedate-textIE' : 'duedate-text'}>
        {`${counterpart('globalTranslate.caseLanding.summaryDay')}${daysLeft.daysLeft === 0 ? counterpart('globalTranslate.caseLanding.summaryDayPlural') : daysLeft.daysLeft > 1 ? counterpart('globalTranslate.caseLanding.summaryDayPlural') : ''} ${counterpart('globalTranslate.caseLanding.summaryDayLeft')}`}
      </span>
    </div>
  );
};

export default DueDate;
